function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import React, { useCallback, useMemo, useRef, useState } from 'react';
import * as monaco from 'monaco-editor';
import { Workspace } from '@astral-sh/ruff-wasm-web';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ActionButton, Button, Icon, Link, Modal, ModalBody, ModalFooter, ModalHeader, Text } from '@deephaven/components';
import { vsLinkExternal, vsDiscard } from '@deephaven/icons';
import { useDebouncedCallback, usePromiseFactory } from '@deephaven/react-hooks';
import { assertNotNull, EMPTY_FUNCTION } from '@deephaven/utils';
import Editor from "../notebook/Editor.js";
import RUFF_DEFAULT_SETTINGS from "./RuffDefaultSettings.js";
import ruffSchema from "./ruffSchema.js";
import "./RuffSettingsModal.css";
import MonacoProviders from "./MonacoProviders.js";
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
var RUFF_SETTINGS_URI = monaco.Uri.parse('inmemory://dh-config/ruff-settings.json');
function registerRuffSchema() {
  var _monaco$languages$jso = monaco.languages.json.jsonDefaults.diagnosticsOptions.schemas,
    schemas = _monaco$languages$jso === void 0 ? [] : _monaco$languages$jso;
  if (!schemas.some(schema => schema.uri === 'json://ruff-schema')) {
    // Register the ruff schema so users get validation and completion
    monaco.languages.json.jsonDefaults.setDiagnosticsOptions({
      schemas: [...schemas, {
        uri: 'json://ruff-schema',
        fileMatch: [RUFF_SETTINGS_URI.toString()],
        schema: ruffSchema
      }]
    });
  }
}
function getRuffVersion() {
  return _getRuffVersion.apply(this, arguments);
}
function _getRuffVersion() {
  _getRuffVersion = _asyncToGenerator(function* () {
    yield MonacoProviders.initRuff();
    return "v".concat(Workspace.version());
  });
  return _getRuffVersion.apply(this, arguments);
}
export default function RuffSettingsModal(_ref) {
  var text = _ref.text,
    isOpen = _ref.isOpen,
    onClose = _ref.onClose,
    onSave = _ref.onSave,
    _ref$readOnly = _ref.readOnly,
    readOnly = _ref$readOnly === void 0 ? false : _ref$readOnly,
    _ref$defaultSettings = _ref.defaultSettings,
    defaultSettings = _ref$defaultSettings === void 0 ? RUFF_DEFAULT_SETTINGS : _ref$defaultSettings;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isValid = _useState2[0],
    setIsValid = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isDefault = _useState4[0],
    setIsDefault = _useState4[1];
  var editorRef = useRef();
  var formattedDefaultSettings = useMemo(() => JSON.stringify(defaultSettings, null, 2), [defaultSettings]);
  var _usePromiseFactory = usePromiseFactory(getRuffVersion),
    ruffVersion = _usePromiseFactory.data;
  var _useState5 = useState(() => monaco.editor.createModel(text, 'json', RUFF_SETTINGS_URI)),
    _useState6 = _slicedToArray(_useState5, 1),
    model = _useState6[0];
  var handleClose = useCallback(() => {
    if (isOpen) {
      onClose();
      editorRef.current = undefined;
      model.dispose();
    }
  }, [isOpen, onClose, model]);
  var handleSave = useCallback(() => {
    if (isOpen) {
      try {
        var _editorRef$current$ge, _editorRef$current;
        onSave(JSON.parse((_editorRef$current$ge = (_editorRef$current = editorRef.current) === null || _editorRef$current === void 0 || (_editorRef$current = _editorRef$current.getModel()) === null || _editorRef$current === void 0 ? void 0 : _editorRef$current.getValue()) !== null && _editorRef$current$ge !== void 0 ? _editorRef$current$ge : ''));
      } catch (_unused) {
        // no-op
      }
      handleClose();
    }
  }, [isOpen, handleClose, onSave]);
  var handleReset = useCallback(() => {
    assertNotNull(model);
    model.setValue(formattedDefaultSettings);
  }, [model, formattedDefaultSettings]);
  var validate = useCallback(val => {
    var _editorRef$current2;
    try {
      JSON.parse(val);
      setIsValid(true);
    } catch (_unused2) {
      setIsValid(false);
    }
    setIsDefault(((_editorRef$current2 = editorRef.current) === null || _editorRef$current2 === void 0 || (_editorRef$current2 = _editorRef$current2.getModel()) === null || _editorRef$current2 === void 0 ? void 0 : _editorRef$current2.getValue()) === formattedDefaultSettings);
  }, [formattedDefaultSettings]);
  var debouncedValidate = useDebouncedCallback(validate, 500, {
    leading: true
  });
  var onEditorInitialized = useCallback(editor => {
    editorRef.current = editor;
    model.onDidChangeContent(() => {
      debouncedValidate(model.getValue());
    });
    registerRuffSchema();
    debouncedValidate(model.getValue());
  }, [debouncedValidate, model]);
  if (!isOpen) {
    return null;
  }
  return /*#__PURE__*/_jsxs(Modal, {
    isOpen: isOpen,
    centered: true,
    keyboard: true,
    clickOutside: false,
    toggle: handleClose,
    size: "lg",
    className: "ruff-settings-modal",
    children: [/*#__PURE__*/_jsxs(ModalHeader, {
      closeButton: false,
      children: [/*#__PURE__*/_jsxs("span", {
        className: "settings-modal-title mr-auto",
        children: ["Ruff ", ruffVersion, " Settings"]
      }), /*#__PURE__*/_jsx(Link, {
        href: "https://docs.astral.sh/ruff/settings/",
        target: "_blank",
        children: /*#__PURE__*/_jsx(Button, {
          kind: "ghost",
          onClick: EMPTY_FUNCTION,
          icon: vsLinkExternal,
          children: "Settings Docs"
        })
      }), /*#__PURE__*/_jsxs(ActionButton, {
        isDisabled: isDefault,
        onPress: handleReset,
        children: [/*#__PURE__*/_jsx(Icon, {
          children: /*#__PURE__*/_jsx(FontAwesomeIcon, {
            icon: vsDiscard
          })
        }), /*#__PURE__*/_jsx(Text, {
          children: "Reset to default"
        })]
      })]
    }), /*#__PURE__*/_jsx(ModalBody, {
      style: {
        height: '80vh'
      },
      children: /*#__PURE__*/_jsx(Editor, {
        onEditorInitialized: onEditorInitialized,
        settings: {
          readOnly,
          value: text,
          language: 'json',
          folding: true,
          padding: {
            bottom: 16
          },
          lineNumbers: 'on',
          overviewRulerLanes: 0,
          model
        }
      })
    }), /*#__PURE__*/_jsx(ModalFooter, {
      children: readOnly ? /*#__PURE__*/_jsx(Button, {
        kind: "secondary",
        "data-dismiss": "modal",
        onClick: handleClose,
        children: "Close"
      }) : /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Button, {
          kind: "secondary",
          "data-dismiss": "modal",
          onClick: handleClose,
          children: "Cancel"
        }), /*#__PURE__*/_jsx(Button, {
          kind: "primary",
          "data-dismiss": "modal",
          tooltip: !isValid ? 'Cannot save invalid JSON' : undefined,
          disabled: !isValid,
          onClick: handleSave,
          children: "Save"
        })]
      })
    })]
  });
}
//# sourceMappingURL=RuffSettingsModal.js.map